import { HttpAccount } from '@/js/http-Manager'

const state = { // 設定值一定是要一個obj
  Roles: [],
  Jwt: null,
  IsLogin: false
}
const getters = { // 取state值給前面元件使用
  parseJwt (state) { // 解析
    var base64Url = state.Jwt.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
  },
  getUserAccountId (state, getters) {
    let jwt = getters.parseJwt

    if (jwt !== '' && jwt !== null) {
      return jwt['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] // 取出name的值
    }
    return ''
  },
  getRoles (state, getters) {
    let jwt = getters.parseJwt

    if (jwt !== '' && jwt !== null) {
      let array = []
      if (typeof jwt['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === 'string') {
        array.push(jwt['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'])
        return array
      }
      return jwt['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] // 取出name的值
    }
    return []
  },
  isLogin (state) {
    return state.IsLogin
  },
  isRoleManagerOrAdmin (state, getters) {
    let roles = getters.getRoles

    if (roles.length > 0) {
      return roles.findIndex(x => x === 'Admin' || x === 'Manager') !== -1
    }

    return false
  },
  isRoleAdmin (state, getters) {
    let roles = getters.getRoles

    if (roles.length > 0) {
      return roles.findIndex(x => x === 'Admin') !== -1
    }

    return false
  }
}
const actions = { // 處理非同步
// Login methods. Either use cookie-based auth or jwt-based auth
  async login ({ commit, dispatch }, credentials) { // dispatch 這個函式是呼叫 action 裡面的方法
    let isLogin = false

    try {
      let response = await HttpAccount.Login(credentials)

      if (response.status === 200) {
        commit('setJwt', response.data.Data.JWT) // commit 這個函式是呼叫 mutation 裡面的方法。
        // commit('setRoles', JSON.stringify(response.data.Data.Roles))
        commit('setLoginStatus', true)

        isLogin = true
      }
    } catch (e) {
      console.error(e)
    }

    return isLogin
  },
  logout ({ commit, state, dispatch }) {
    commit('setJwt', null)
    // commit('setRoles', null)
    commit('setLoginStatus', false)
    dispatch('permission/reset', null, { root: true })
  }
}
const mutations = { // 更新資料狀態的地方，只能透過mutations去更改State的值
  setJwt (state, Jwt) {
    state.Jwt = Jwt
    if (Jwt) window.localStorage.setItem('Jwt', Jwt)
    else window.localStorage.removeItem('Jwt')
  },
  setRoles (state, roles) {
    state.Roles = roles
    if (roles) window.localStorage.setItem('roles', roles)
    else window.localStorage.removeItem('roles')
  },
  setLoginStatus (state, isLogin) {
    state.IsLogin = isLogin
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
